import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { JobService } from 'src/app/admihair/service/job.service';
import { PageResponse } from 'src/app/admihair/api/dto/paginacao/page-response';
import { Table } from 'primeng/table';
import { MonitoramentoJob } from 'src/app/admihair/api/dto/monitoramento-job';
import { Job } from 'src/app/admihair/api/dto/job';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent extends AdmihairBaseComponent implements OnInit {

  permissaoJobs: boolean = false;
  loading: boolean = true;
  loadingExecutar: boolean = false;
  exibirDialogDetalheJob: boolean = false;
  monitoramentoJobSelecionado?: MonitoramentoJob;
  listaJobsDialog: Job[] = [];
  loadingJobsDialog: boolean = false;

  itensPaginados: PageResponse<MonitoramentoJob> = {
    content: [],
    number: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    last: false
  }
  ordenacao: string = "dia,ASC";
  numeroPagina: number = 0;
  tamanhoPagina: number = 10;

  opcoesFiltroJobs: SelectItem[] = [
    { label: 'TODOS', value: undefined },
    { label: 'VENCER ORÇAMENTOS/PACOTES', value: 'VENCER_ORCAMENTOS_E_PACOTES' },
    { label: 'PAGAR DESPESA AGENDADA', value: 'PAGAR_DESPESA_AGENDADA' },
    {label: 'FECHAMENTO AGENDAMENTOS', value: 'FECHAMENTO_AGENDAMENTOS'}
  ]

  dataFiltroInicio: Date = new Date();
  dataFiltroFim: Date = new Date();

  filtroJobSelecionado?: string = undefined;

  constructor(private jobService: JobService,
    erroService: ErroService,
    storageService: UtilStorageService,
  ) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoJobs = this.verificarPermissao('PERM_JOBS');
  }

  listar() {
    this.loading = true;
    this.jobService.listar(
      this.filtroJobSelecionado,
      this.numeroPagina,
      this.tamanhoPagina,
      this.ordenacao,
      this.dataFiltroInicio,
      this.dataFiltroFim
    ).subscribe({
      next: (data: PageResponse<MonitoramentoJob>) => {
        this.itensPaginados = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  abrirDialogDetalhe(item: MonitoramentoJob) {
    this.monitoramentoJobSelecionado = item;
    this.exibirDialogDetalheJob = true;
    this.listarJobsPorNomeEData();

  }

  listarJobsPorNomeEData() {
    this.loadingJobsDialog = true;
    this.jobService.listarPorNomeEData(
      this.monitoramentoJobSelecionado?.nome,
      this.monitoramentoJobSelecionado?.dia
    ).subscribe({
      next: (data: Job[]) => {
        this.listaJobsDialog = data;
        this.loadingJobsDialog = false;
      },
      error: (err: any) => {
        this.loadingJobsDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  executar(item: MonitoramentoJob) {
    item.isLoading = true;
    const job = {
      nome: item.nome,
      data: item.dia
    }
    this.jobService.processar(job).subscribe({
      next: () => {
        this.listar();
        item.isLoading = false;
      },
      error: (err: any) => {
        item.isLoading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  filtrarPorData() {
    if (this.dataFiltroInicio && this.dataFiltroFim) {
      this.listar();
    }
  }

  onLazyLoad(event: LazyLoadEvent) {

    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    if (event.rows) {
      this.tamanhoPagina = event.rows;
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.listar();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    const campoDeOrdenacao = sortField ? sortField : "dia";
    const direcaoOrdenacao = sortOrder === -1 ? "DESC" : "ASC";
    this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
  }

  limpar(table: Table) {
    this.filtroJobSelecionado = undefined;
    this.dataFiltroInicio = new Date();
    this.dataFiltroFim = new Date();
    table.clear();
  }

}
